/**
 * Module dependencies.
 */

import { DatePickerField } from 'app/components/atoms/forms/fields/date-picker/date-picker-field';
import React from 'react';
import { DatePickerSearch } from '../form-filters-type';
import { FilterOptions } from './types';

/**
 * Export `FilterDatePickerField` component.
 */

export function FilterDatePickerField(props: FilterOptions<DatePickerSearch>): JSX.Element {
  const { disabled, form, item } = props;
  const { label, name, placeholder, disabledDate } = item;
  const { control, watch } = form;
  const values = watch();

  return (
    <DatePickerField
      control={control}
      disabled={disabled}
      disabledDate={disabledDate ? (date: any) => disabledDate(date, values) : undefined}
      label={label}
      name={name}
      placeholder={placeholder ?? label}
    />
  );
}
